import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchTemplatesByType } from '../apis/fetchTemplatesByType';
import type { TemplatePDF } from '../types/template';
import type { ApiResponse } from '../../../types/apiResponse';
import withPrefix from '../../../helpers/useQueryPrefix';

export const useFetchTemplatesByType = (type: 'contract' | 'bill'): UseQueryResult<TemplatePDF[], Error> => {
	return useQuery<ApiResponse<TemplatePDF[]>, Error, TemplatePDF[]>({
		queryKey: withPrefix(['templates', type]),
		queryFn: () => fetchTemplatesByType(type),
		select: (response) => {
			if (response.status !== 200) {
				throw new Error(response.message);
			}
			return response.data as TemplatePDF[];
		},
	});
};
